import { useConfluenceDependencies } from '../../../../controllers/use-confluence-dependencies';

export const FALLBACK_URL = 'https://www.atlassian.com/';

export const useSmartCardFallbackUrl = () => {
	const { currentDataRefHref } = useConfluenceDependencies();

	const baseUrl = window.location.origin;

	return currentDataRefHref ? `${baseUrl}${currentDataRefHref}` : FALLBACK_URL;
};
